import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import logo from "../../assets/Logo_Prosperidad_Social.png";
import logo472 from "../../assets/logo_427.png";

const ExportarReporteAprobados = ({ data = [] }) => {
    const handleDownloadExcel = async () => {
        if (!data || data.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Reporte KOKAN");

        // 🔥 === LOGOS ===
        const response1 = await fetch(logo);
        const blob1 = await response1.blob();
        const buffer1 = await blob1.arrayBuffer();
        const imageId1 = workbook.addImage({ buffer: buffer1, extension: "png" });

        const response2 = await fetch(logo472);
        const blob2 = await response2.blob();
        const buffer2 = await blob2.arrayBuffer();
        const imageId2 = workbook.addImage({ buffer: buffer2, extension: "png" });

        // 🔥 ALTURA FILAS
        worksheet.getRow(1).height = 30;
        worksheet.getRow(2).height = 30;
        worksheet.getRow(3).height = 30;

        // 🔥 LOGO PRINCIPAL
        worksheet.mergeCells("A1:B3");
        worksheet.addImage(imageId1, {
            tl: { col: 0, row: 0 },
            br: { col: 2, row: 3 },
        });

        // 🔥 LOGO SECUNDARIO
        worksheet.mergeCells("C1:C3");
        worksheet.getColumn(3).width = 14;
        worksheet.addImage(imageId2, {
            tl: { col: 2.99, row: 1 },
            ext: { width: 160, height: 40 },
        });

        // 🔥 TITULO
        worksheet.mergeCells("D1:H2");
        const titleCell = worksheet.getCell("D1");
        titleCell.value = "REPORTE APROBADOS KOKAN";
        titleCell.font = { size: 16, bold: true, color: { argb: "FF1B5E20" } };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };

        // 🔥 FECHA
        worksheet.mergeCells("D3:H3");
        const dateCell = worksheet.getCell("D3");
        dateCell.value = `Fecha de consulta: ${new Date().toLocaleDateString()}`;
        dateCell.alignment = { horizontal: "center", vertical: "middle" };

        // 🔥 FILA VACÍA
        worksheet.addRow([]);

        // 🔥 CABECERA
        const headerRow = worksheet.addRow([
            "Cédula titular",
            "Nombre titular",
            "Municipio titular",
            "Municipio KOKAN",
            "Teléfono",
            "Dirección",
            "Validación KOKAN",
            "Validación pago",
            "Encuestador",
            "Cédula encuestador",
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF2E7D32" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // 🔥 CONSTANTES DE COLUMNAS (para evitar errores)
        const COL_VALIDACION_KOKAN = 7;
        const COL_VALIDACION_PAGO = 8;

        // 🔥 DATA
        data.forEach((item) => {
            const valorPago = (() => {
                const raw = item.aprobacionPago;
                if (raw === "SI") return "Sí";
                if (raw === "NO") return "No";
                if (!raw) return "Sin dato";
                return String(raw);
            })();

            const row = worksheet.addRow([
                item.identificacion,
                item.nombre_completo,
                item.municipio_participante_nombre,
                item.municipio_kokan_nombre,
                item.telefono || "Sin dato",
                item.direccion || "Sin dato",
                item.validacion_municipio,
                valorPago,
                `${item.nombres_promotor} ${item.apellidos_promotor}`,
                item.cedula_promotor,
            ]);

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };

                // ✅ Validación KOKAN
                if (colNumber === COL_VALIDACION_KOKAN && cell.value === "DIFERENTE") {
                    cell.font = { bold: true, color: { argb: "FFFF0000" } };
                }

                // ✅ Validación pago
                if (colNumber === COL_VALIDACION_PAGO) {
                    const aprobado = cell.value === "Sí";
                    cell.font = {
                        bold: true,
                        color: { argb: aprobado ? "FF2E7D32" : "FFFF0000" },
                    };
                }
            });
        });

        // 🔥 AJUSTE DE COLUMNAS (YA SON 10)
        worksheet.columns = [
            { width: 18 },
            { width: 30 },
            { width: 25 },
            { width: 25 },
            { width: 18 },
            { width: 28 }, // dirección más amplia
            { width: 22 },
            { width: 20 },
            { width: 30 },
            { width: 22 },
        ];

        // 🔥 GENERAR ARCHIVO
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `Reporte_Aprobados_KOKAN_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
    };

    return (
        <Button
            icon={<FileExcelOutlined />}
            style={{ backgroundColor: "#2e7d32", borderColor: "#2e7d32", color: "white" }}
            onClick={handleDownloadExcel}
        >
            Exportar Excel
        </Button>
    );
};

export default ExportarReporteAprobados;